module.exports = __webpack_public_path__ + "6e3aa8be2b309c8762023eb7d970fa39.svg";